import React from 'react';
import '../../styles/components/HomeSection/MarketButtons.css';

interface GooglePlayButtonProps {
}

const GooglePlayButton: React.FC<GooglePlayButtonProps> = () => {
  return (
    <a 
      href="https://play.google.com/store/apps/details?id=com.yohavb.rushhour" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`market-btn google-btn`}
    >
      <span className="market-button-subtitle">GET IT ON</span>
      <span className="market-button-title">Google Play</span>
    </a>
  );
};

export default GooglePlayButton;
